import React from 'react';

const HomeSection = ({
  eyebrow,
  title,
  description,
  action,
  children,
  id,
  fullBleed = false,
}) => (
  <section className={`home-section${fullBleed ? ' home-section--bleed' : ''}`} id={id}>
    <div className="home-section__container">
      {(eyebrow || title || description || action) && (
        <div className="home-section__header">
          <div className="home-section__intro">
            {eyebrow && <span className="home-section__eyebrow">{eyebrow}</span>}
            {title && <h2 className="home-section__title">{title}</h2>}
            {description && <p className="home-section__description">{description}</p>}
          </div>
          {action}
        </div>
      )}
      {!fullBleed && <div className="home-section__body">{children}</div>}
    </div>
    {fullBleed && <div className="home-section__body home-section__body--bleed">{children}</div>}
  </section>
);

export default HomeSection;
